module.exports = __webpack_public_path__ + "01fc4f4a3bb68e0bed3f47d6f54b4aa3.svg";